import { render, staticRenderFns } from "./AreaEdit.vue?vue&type=template&id=21359ca8"
import script from "./AreaEdit.vue?vue&type=script&lang=ts"
export * from "./AreaEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports